"use client";

import { Button } from '@/components/ui/button';
import { Music2, RefreshCw, ArrowLeft } from 'lucide-react';

export default function MusicError({ reset }: { error: Error; reset: () => void }) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[50vh] px-4 text-center gap-5">
      <div className="h-14 w-14 rounded-full bg-muted flex items-center justify-center">
        <Music2 className="h-7 w-7 text-muted-foreground" />
      </div>
      <div className="space-y-1.5">
        <h2 className="text-xl font-semibold">Couldn&apos;t load this track</h2>
        <p className="text-sm text-muted-foreground">It may have been removed or there was a connection issue.</p>
      </div>
      <div className="flex gap-3">
        <Button onClick={reset} size="sm" className="gap-2">
          <RefreshCw className="h-3.5 w-3.5" />Try again
        </Button>
        <Button onClick={() => history.back()} size="sm" variant="outline" className="gap-2">
          <ArrowLeft className="h-3.5 w-3.5" />Go back
        </Button>
      </div>
    </div>
  );
}
